import FeedbackSettingsDialog from 'components/CreateAssignment/FeedbackSettingsDialog';
import RubricDialogs from 'components/CreateQuiz/RubricDialogs';
import EditQuizLayout from 'components/EditQuiz/EditQuizLayout';
import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/EditQuiz/PageProvider';
import ErrorPage from 'pages/Error/404';
import { useContext } from 'react';
import { Loading } from 'shell/components';

const PageLayout = () => {
    const { device } = useViewport();
    const {
        draft,
        quiz,
        form,
        loading,
        loadFailed,
        feedbackDialogOpen,
        setFeedbackDialogOpen,
        handleSaveFeedback,
        ...props
    } = useContext(PageContext);

    if (loading || !draft || !quiz || !form) return loadFailed ? <ErrorPage /> : <Loading />;

    return (
        <>
            <EditQuizLayout device={device} quiz={quiz} {...props} />
            <RubricDialogs />
            <FeedbackSettingsDialog
                isQuizFeedback
                open={feedbackDialogOpen}
                form={form}
                onClose={() => setFeedbackDialogOpen(false)}
                onSave={handleSaveFeedback}
            />
        </>
    );
};

export default PageLayout;
